import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useInterval from "lib/useInterval";
import axios from "axios";

export default function DashCard(props) {
  const [display, setDisplay] = useState({});

  async function getTicketsInView(id) {
    const { data } = await axios.get(
      `https://us-east5-festive1.cloudfunctions.net/getTicketsInViewById?view=${id}`
    );
    setDisplay(data);
  }

  useEffect(() => {
    // Call API to get latest slaCount
    getTicketsInView(props.view);
  }, []);

  useInterval(() => {
    // Call API to get latest slaCount
    getTicketsInView(props.view);
  }, 60000);

  return (
    <div
      className={`card mb-4 shadow text-center`}
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={props.tooltip}
    >
      {" "}
      <h6 className="card-header text-secondary">
        {props.title ? props.title : props.view}
      </h6>
      <div className={`card-body text-center`}>
        <h4 className="card-text text-dark">{display.numOfTickets}</h4>{" "}
      </div>
    </div>
  );
}
